<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5" style="min-width: 300px;">
        <v-card 
          v-if="mode == 'login'"
          class="elevation-12"
        >
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Авторизация</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn outlined href="https://lp.soyuz-otdelka.ru">Подключение к системе</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="isAuthForm" ref="authForm">
              <v-alert 
                dense 
                outlined
                type="error" 
                :value="Boolean(serverError)"
                transition="scale-transition"
              >
                {{ serverError }}
              </v-alert>
              <v-text-field
                v-model="email"
                label="Email"
                :rules="[v => !!v || 'Введите email.', v => isEmail(v) || 'Введите корректный email.']"
                prepend-icon="mdi-account"
                :disabled="loadingAuth"
                @focus="serverError = ''"
                autocomplete="username"
                filled
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Пароль"
                :rules="[v => !!v || 'Введите пароль.']"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :disabled="loadingAuth"
                @focus="serverError = ''"
                autocomplete="current-password"
                filled
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              color="blue darken-1"
              text 
              @click="serverError = false; serverSuccess = false; mode = 'recovery';"
              :disabled="loadingAuth"
            >Забыли пароль?</v-btn>

            <v-spacer></v-spacer>
            
            <v-btn 
              color="primary" 
              @click="serverError = false; login()"
              :loading="loadingAuth"
              :disabled="loadingAuth"
            >Войти</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-if="mode == 'recovery'">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
            <v-spacer></v-spacer>
            
          </v-toolbar>
          <v-card-text>
            <v-form v-model="isRecoveryForm" ref="recoveryForm">
              <v-alert 
                dense 
                outlined
                type="error" 
                :value="Boolean(serverError)"
                transition="scale-transition"
              >
                {{ serverError }}
              </v-alert>

              <v-alert 
                dense 
                outlined
                type="success" 
                :value="Boolean(serverSuccess)"
                transition="scale-transition"
              >
                Инструкция по восстановлению пароля отправлена на email.
              </v-alert>

              <v-text-field
                v-model="email"
                label="Email"
                :rules="[v => !!v || 'Введите email.', v => isEmail(v) || 'Введите корректный email.']"
                prepend-icon="mdi-account"
                :disabled="loadingSendCode || serverSuccess"
                @focus="serverError = ''"
                filled
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              color="blue darken-1"
              text 
              @click="serverError = false; serverSuccess = false; mode = 'login';"
              :disabled="loadingSendCode"
            >Авторизация</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              color="primary" 
              @click="serverError = false; recovery();"
              :loading="loadingSendCode"
              :disabled="loadingSendCode || serverSuccess"
            >Восстановить</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-if="mode == 'newpass'">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Получение нового пароля</v-toolbar-title>
            <v-spacer></v-spacer>
            
          </v-toolbar>
          <v-card-text>
            <v-progress-linear 
              :active="loadingUpdatePass"
              indeterminate
            ></v-progress-linear>

            <v-alert 
              dense 
              outlined
              type="error" 
              :value="Boolean(serverError)"
              transition="scale-transition"
            >
              {{ serverError }}
            </v-alert>

            <v-alert 
              dense 
              outlined
              type="success" 
              :value="Boolean(serverSuccess)"
              transition="scale-transition"
            >
              Новый пароль отправлен на ваш email.
            </v-alert>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              color="blue darken-1"
              text 
              :disabled="loadingUpdatePass"
              @click="serverError = false; serverSuccess = false; mode = 'login';"
              
            >Авторизация</v-btn>
            
          </v-card-actions>
        </v-card>        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import validator from 'validator';

export default {
  data() {
    return {
      mode: 'login',

      email: '',
      password: '',
      showPassword: false,
      
      serverError: '',
      serverSuccess: false,
      
      isAuthForm: false,
      isRecoveryForm: false
    }
  },
  
  created() {
    document.title = 'Авторизация';
    if (this.$route.query.recovery) {
      this.mode = 'newpass';
      this.newpass();
    }
  },

  methods: {
    login() {
      this.$refs.authForm.validate();
      if (this.isAuthForm) {
        this.$store.dispatch('users/processAuth', {
          email: this.email, 
          password: this.password
        })
        .then(result => {
          this.$router.push('/');
        })
        .catch(err => {
          this.serverError = err.message;
        });
      }
    },

    recovery() {
      this.$refs.recoveryForm.validate();

      if (this.isRecoveryForm) {
        this.$store.dispatch('users/sendRecoveryCode', this.email)
        .then(result => {
          this.serverSuccess = true;
        })
        .catch(err => {
          this.serverError = err.message;
        });
      }
    },

    newpass() {
      this.$store.dispatch('users/updatePassword', this.$route.query.recovery)
      .then(result => {
        this.serverSuccess = true;
      })
      .catch(err => {
        this.serverError = err.message;
      });
    },

  },

  computed: {
    ...mapGetters('users', ['loadingAuth', 'loadingSendCode', 'loadingUpdatePass'])
  },
}
</script>